import { TicketSettingDetail } from "@/api/system/ticketSetting";
import localStorage from "@/utils/localStorage";

const state = {
    saleType: localStorage.get("saleType") || "CALL"
};

const getters = {
    saleType: state => state.saleType
};

const mutations = {
    setSaleType(state, saleType) {
        console.log("setSaleType执行了", saleType);
        state.saleType = saleType;
        localStorage.set("saleType", saleType);
    }
};

const actions = {
    // 获取订单设置
    async getOrderSetting({ commit }) {
        let setSaleType = "CALL";
        const storeId = localStorage.get("storeId");
        if (storeId) {
            let params = {
                storeId: storeId
            };
            const res = await TicketSettingDetail(params);
            console.log("订单设置", res);
            if (res.data.saleType) {
                setSaleType = res.data.saleType;
            }
        }
        commit("setSaleType", setSaleType);
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
